import axios from "axios";
import Spinners from "Components/Common/Spinner";
import React, { useState } from "react";
import "./assets/scss/themes.scss";
import Route from "./Routes";

const App = () => {
  const [loading, setLoading] = useState(false);

  axios.interceptors.response.use(
    async (config) => {
      if (config) {
        setLoading(true);
        return config;
      }
      return config;
    },
    (error) => {
      console.error(error);
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    (response) => {
      const timeoutId = setTimeout(() => {
        setLoading(false);
      }, 400);
      return response;
    },
    (error) => {
      console.error(error);
      return Promise.reject(error);
    }
  );

  return (
    <React.Fragment>
      <Spinners exibir={loading}></Spinners>
      <Route />
    </React.Fragment>
  );
};

export default App;
